import { reactive } from "vue";
const context = reactive({})

/**
 *
 * @param String name
 * @param {format:Function} config
 * @returns
 */
export const defineDatasource = (name, config = { execute: () => { } }) => {
    if (!name) {
        return
    }
    context[name] = config
}

export const getDatasource = (name='default') => {
    return context[name]
}
